import React from 'react';
import { MAIN_URL } from '@lib/constants';
import { SchemaCenterProps } from './SchemaCenter.types';

const SchemaCenter = ({
  id = '',
  title,
  openingTime,
  closingTime,
  openingTimeFriday,
  closingTimeFriday,
  address,
  city,
  coordinates,
  description,
  url,
  image,
  postalCode,
  products,
}: SchemaCenterProps) => {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'AutoRepair',
    name: title,
    ...(description && { description }),
    ...(url && { url }),
    ...(image && { image }),
    openingHours: [`Mo-Th ${openingTime}-${closingTime}`, `Fr ${openingTimeFriday}-${closingTimeFriday}`],
    address: {
      '@type': 'PostalAddress',
      streetAddress: address,
      addressLocality: city,
      addressRegion: city,
      ...(postalCode && { postalCode }),
      addressCountry: 'NO',
    },
    telephone: '08505',
    ...(products &&
      products.length > 0 && {
        hasOfferCatalog: {
          '@type': 'OfferCatalog',
          name: 'Verkstedtjenester',
          itemListElement: products.map((product) => {
            const serviceUrl = product.link?.data?.slug ? `${MAIN_URL}/${product.link.data.slug}` : null;
            const price = product.memberPrice?.isCampaign
              ? product.memberPrice.campaignPrice
              : product.memberPrice?.price || product.nonMemberPrice?.price;

            return {
              '@type': 'Offer',
              itemOffered: {
                '@type': 'Service',
                name: product.name,
                ...(product.ingress && { description: product.ingress }),
                ...(serviceUrl && { url: serviceUrl }),
              },
              ...(price && { price: price.toString(), priceCurrency: 'NOK' }),
            };
          }),
        },
      }),
    ...(coordinates?.latitude &&
      coordinates?.longitude && {
        geo: {
          '@type': 'GeoCoordinates',
          latitude: coordinates.latitude,
          longitude: coordinates.longitude,
        },
      }),
    parentOrganization: {
      '@type': 'Organization',
      name: 'NAF',
      url: MAIN_URL,
    },
  };

  return (
    <script
      type="application/ld+json"
      key={`centerJSON-${id}`}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  );
};

export default SchemaCenter;
